//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';

export default {
  name: 'Footer',
  props: {
    filterMenu: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      whiteLabelLogo: 'whitelabel/whiteLabelLogo',
    }),
    footerMenu() {
      return this.$store.state.menuFooter;
    },
  },
};
